// extracted by mini-css-extract-plugin
module.exports = {"field":"BSelectWithValdation_field_3zasI"};